import {CustomerInterface} from './customerInterface';

export class Customer implements CustomerInterface {

    /**
     * @var
     */
    public company: string;

    /**
     * @var
     */
    public customerNumber: string;

    /**
     * @var
     */
    public name: string;

    /**
     * @var
     */
    public street: string;

    /**
     * @var
     */
    public postCode: string;

    /**
     * @var
     */
    public city: string;

    /**
     * @var
     */
    public phone: string;

    /**
     * @var
     */
    public fax: string;

    /**
     * @var
     */
    public comments: string;

    /**
     * @var
     */
    public email: string;

    /**
     * @var
     */
    public consentDeclared: boolean;

}



// WEBPACK FOOTER //
// ./src/model/customer.ts